export default __webpack_public_path__ + "static/media/@pearldavinci.74915446.jpeg";